var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path8, _rect7, _g, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.0352 45.4727C89.0352 52.0815 87.5919 58.3596 85.0001 64.0003C77.9763 79.3287 62.4975 89.9727 44.5352 89.9727C26.5728 89.9727 11.094 79.3287 4.07022 64.0003C1.4784 58.3596 0.0351562 52.0815 0.0351562 45.4727C0.0351562 20.8954 19.9579 0.972656 44.5352 0.972656C69.1124 0.972656 89.0352 20.8954 89.0352 45.4727Z",
    fill: "#F4F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7203 65.3201V65.3202H58.4116C55.835 65.3202 53.7462 63.2314 53.7462 60.6548C53.7462 58.0781 55.835 55.9893 58.4116 55.9893H12.3026C12.2937 55.9893 12.2847 55.9893 12.2758 55.9893H10.7206C7.28511 55.9893 4.50005 58.7743 4.50005 62.2098V65.3201H10.7203Z",
    fill: "url(#paint0_linear_850_1163)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7866 66.7893C40.7866 60.8246 35.9513 55.9893 29.9866 55.9893H11.7572V66.9613C11.7572 72.926 16.5925 77.7613 22.5572 77.7613H40.7866V66.7893Z",
    fill: "url(#paint1_linear_850_1163)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1616 24.8C23.1616 18.8353 27.9969 14 33.9616 14H69.816V58.861C69.816 69.2992 61.3542 77.761 50.916 77.761H23.1616V24.8Z",
    fill: "url(#paint2_linear_850_1163)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8158 26.4412H27.8271C31.2627 26.4412 34.0477 23.6561 34.0477 20.2206C34.0477 16.7851 31.2627 14 27.8271 14H69.8158C69.8159 14 69.8161 14 69.8162 14C73.2517 14 76.0368 16.7851 76.0368 20.2206C76.0368 23.6561 73.2517 26.4412 69.8162 26.4412C69.8161 26.4412 69.8159 26.4412 69.8158 26.4412Z",
    fill: "url(#paint3_linear_850_1163)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1615 71.5411H23.1617V77.7617H17.4595C20.6086 77.7616 23.1615 75.2087 23.1615 72.0595V71.5411Z",
    fill: "#D4D8E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7573 55.9894L11.7573 62.21L11.7573 62.21L11.7573 58.0628C11.7573 56.9249 10.8407 56.0011 9.70558 55.9894L11.7573 55.9894Z",
    fill: "#D0D4DE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.6768,
    y: 43.5479,
    width: 26.9559,
    height: 4.14706,
    rx: 2.07353,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4189,
    y: 43.5479,
    width: 4.14706,
    height: 4.14706,
    rx: 2.07353,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6768,
    y: 52.8789,
    width: 21.2537,
    height: 4.14706,
    rx: 2.07353,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4189,
    y: 52.8789,
    width: 4.14706,
    height: 4.14706,
    rx: 2.07353,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6768,
    y: 34.2168,
    width: 26.9559,
    height: 4.14706,
    rx: 2.07353,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4189,
    y: 34.2168,
    width: 4.14706,
    height: 4.14706,
    rx: 2.07353,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5771 44.7504C81.1608 44.6451 80.9086 44.2222 81.014 43.8058L81.3954 42.2982C81.5007 41.8819 81.9236 41.6298 82.3399 41.7351C82.7562 41.8404 83.0083 42.2633 82.903 42.6796L82.5216 44.1873C82.4163 44.6036 81.9934 44.8557 81.5771 44.7504ZM83.9337 46.8215C83.7724 46.4235 83.9642 45.9701 84.3622 45.8087L85.8034 45.2244C86.2014 45.0631 86.6548 45.2549 86.8161 45.6529C86.9775 46.0509 86.7856 46.5043 86.3877 46.6657L84.9465 47.2499C84.5485 47.4113 84.095 47.2195 83.9337 46.8215ZM84.5886 49.7986C84.1733 49.6889 83.7479 49.9367 83.6382 50.3519C83.5286 50.7671 83.7763 51.1926 84.1916 51.3022L85.6952 51.6992C86.1104 51.8088 86.5359 51.5611 86.6455 51.1459C86.7551 50.7307 86.5074 50.3052 86.0922 50.1956L84.5886 49.7986Z",
    fill: "#A1A5AC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5812,
    y: 65.0801,
    width: 1.03947,
    height: 6.59206,
    transform: "rotate(-45 75.5812 65.0801)",
    stroke: "url(#paint4_linear_850_1163)",
    strokeWidth: 1.03947
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_850_1163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1551 69.3265C76.2143 68.3857 76.2143 66.8604 77.1551 65.9196C78.0959 64.9788 79.6212 64.9788 80.5619 65.9196L87.5319 72.8896C88.4727 73.8304 88.4727 75.3557 87.5319 76.2965C86.5912 77.2373 85.0659 77.2373 84.1251 76.2965L77.1551 69.3265Z",
    fill: "url(#paint5_linear_850_1163)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7023 53.9151C80.7023 61.9313 74.2038 68.4298 66.1876 68.4298C58.1713 68.4298 51.6729 61.9313 51.6729 53.9151C51.6729 45.8988 58.1713 39.4004 66.1876 39.4004C74.2038 39.4004 80.7023 45.8988 80.7023 53.9151Z",
    fill: "#D9DCE0",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1876 63.7644C71.6272 63.7644 76.0368 59.3547 76.0368 53.9151C76.0368 48.4755 71.6272 44.0658 66.1876 44.0658C60.748 44.0658 56.3383 48.4755 56.3383 53.9151C56.3383 59.3547 60.748 63.7644 66.1876 63.7644ZM66.1876 68.4298C74.2038 68.4298 80.7023 61.9313 80.7023 53.9151C80.7023 45.8988 74.2038 39.4004 66.1876 39.4004C58.1713 39.4004 51.6729 45.8988 51.6729 53.9151C51.6729 61.9313 58.1713 68.4298 66.1876 68.4298Z",
    fill: "url(#paint6_linear_850_1163)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_850_1163",
    x: 75.5497,
    y: 63.4139,
    width: 12.6876,
    height: 13.5881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.9,
    dy: -1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.362969 0 0 0 0 0.386115 0 0 0 0 0.420833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_850_1163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_850_1163",
    x1: 30.0449,
    y1: 65.0371,
    x2: 30.055,
    y2: 56.4718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C5CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953081,
    stopColor: "#B1B4BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_850_1163",
    x1: 25.5123,
    y1: 77.1009,
    x2: 25.6137,
    y2: 57.1156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8ADB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_850_1163",
    x1: 47.7097,
    y1: 75.827,
    x2: 47.552,
    y2: 32.9215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D5DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_850_1163",
    x1: 58.1525,
    y1: 14,
    x2: 58.1525,
    y2: 27.4779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970777,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_850_1163",
    x1: 75.0318,
    y1: 66.1703,
    x2: 78.0061,
    y2: 66.8217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_850_1163",
    x1: 85.3822,
    y1: 69.222,
    x2: 76.174,
    y2: 76.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_850_1163",
    x1: 54.2648,
    y1: 43.5474,
    x2: 80.7023,
    y2: 64.8011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB0B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.a75cfa19f184f1b42f60efcdbfb17010.svg";
export { ForwardRef as ReactComponent };